import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CallTaskState } from "../../call-management.types.js";
const CardWrapper = styled("div", {
  shouldForwardProp: (props) => props !== "status" && props !== "isActive"
})(({ theme, status, isActive }) => ({
  boxShadow: "none",
  background: theme.palette.common.white,
  fontFamily: "Lato, sans-serif",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  minWidth: "280px",
  minHeight: "100px",
  marginBottom: "16px",
  borderRadius: "8px",
  padding: "8px",
  boxSizing: "border-box",
  border: `1px solid ${theme.palette.common.white}`,
  ...status === CallTaskState.Open_InProgress && {
    backgroundColor: theme.palette.success[50],
    borderColor: theme.palette.success[600]
  },
  ...(status === CallTaskState.Open_Ringing || isActive) && {
    backgroundColor: theme.palette.secondary[25],
    borderColor: theme.palette.secondary[500]
  }
}));
const CardNameWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start"
}));
const CardHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  width: "100%"
}));
const IconWrapper = styled("div", {
  shouldForwardProp: (props) => props !== "status" && props !== "isActive"
})(({ theme, status, isActive }) => ({
  marginRight: "4px",
  color: theme.palette.error[500],
  ...(status === CallTaskState.Done || status === CallTaskState.Done_AvailyBooking) && {
    color: theme.palette.success[400]
  },
  ...status === CallTaskState.Ignored && {
    color: theme.palette.grey[400]
  },
  ...status === CallTaskState.Open_InProgress && {
    color: theme.palette.success[400]
  },
  ...(status === CallTaskState.Open_Ringing || isActive) && {
    color: theme.palette.secondary[500]
  },
  "&& > *": {
    fontSize: "18px"
  }
}));
const CardFooter = styled("div", {
  shouldForwardProp: (props) => props !== "showButton"
})(({ showButton }) => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
  width: "100%",
  ...showButton && {
    justifyContent: "flex-end"
  }
}));
const CardUserDetails = styled("div")(() => ({
  display: "flex",
  flexDirection: "column"
}));
const LastCallbackTime = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600]
}));
export {
  CardFooter,
  CardHeader,
  CardNameWrapper,
  CardUserDetails,
  CardWrapper,
  IconWrapper,
  LastCallbackTime
};
